// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1___bdd8653843bf3f723d6","cls2":"CollapsedActivityPreview-cls2__e3fcf987d75563d0f7ef CollapsedActivityPreview-cls1___bdd8653843bf3f723d6"};